'use client';

import Script from 'next/script';
import HeapClient from './heap_client';

export default function HeadScripts() {
  return (
    <>
      <HeapClient />
    </>
  );
} 